import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { useHistory } from "react-router-dom";
import Moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import { GetDefaultVideo, GetEvent } from '../helpers/ConfigApi';

import Loading from "./Loading";
import VideoPlayer from '../components/video/VideoPlayerJS';
import AddThis from '../components/plugins/AddThis';
import Sessions from '../components/agenda/Sessions';

const useStyles = makeStyles(theme => ({
  player: {
    paddingTop: theme.spacing(3),
  },
  grid: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  container: {
    color: '#fff'
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  small: {
    fontSize: '0.8em'
  },
  title: {
    textTransform: 'uppercase',
    fontFamily: theme.headings.fontFamily,
  },
  findmore: {
    textTransform: 'uppercase',
    fontFamily: theme.headings.fontFamily,
    color: theme.palette.primary.main,
  },
  share: {
    paddingBottom: theme.spacing(2),
  },
  sessions: {
    borderTop: 'solid 1px #999',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(6),
  },
  agenda: {
    textTransform: 'uppercase',
    fontFamily: theme.headings.fontFamily,
    paddingBottom: theme.spacing(1),
    color: '#fff'
  },
  eventdate: {
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    paddingBottom: theme.spacing(1)
  },
  category: {
    paddingTop: theme.spacing(1) / 2
  },
  button: {
    fontSize: '0.8em'
  },
  footnote: {
    fontSize: '0.9em',
    fontWeight: 500,
    fontStyle: 'italic'
  }
}));

export default (props) => {
  // const history = useHistory();

  const { id } = props.match.params;
  const event = useMemo(() => GetEvent(props.config, id), [props.config, id])
  const defaultVideo = useMemo(() => GetDefaultVideo(event), [event]);
  const playerRef = useRef();

  const [message] = useState({ type: 'info', description: "Loading ... " });
  const [playerSrc, setPlayerSrc] = useState(defaultVideo);
  const [childSrc, setChildSrc] = useState(playerSrc);

  useEffect(() => {
    setPlayerSrc(childSrc);
  }, [childSrc]);
  // const updateVideoFromChild = (vod) => {
  //   setChildSrc(vod);
  // }

  useEffect(() => {
    // if the player is currently playing the default video
    // reload it, if the defaultVideo has been changed,
    // or a video src has been updated in the config file
    if (playerSrc && event && event.content && event.content.videos) {
      for (let i = 0; i < event.content.videos.length; i++) {
        if (playerSrc.id === event.content.videos[i].id) {
          setChildSrc(defaultVideo);
        }
      }
    }
  }, [playerSrc, event, defaultVideo]);

  const setCurrentTime = (duration) => {
    console.log('setCurrentTime', duration);
    if (playerRef && playerRef.current) {
      const secs = Moment.duration(duration).asSeconds()
      playerRef.current.setCurrentTime(secs);
    }
  };

  const classes = useStyles();
  return (
    <>
      <Container>
        {!event &&
          <Loading message={message} />
        }
        {playerSrc &&
          <div className={classes.player}>
            <VideoPlayer src={playerSrc} userId={props.user.attributes.email} ref={playerRef} />
          </div>
        }
        {event && event.content &&
          <Grid container spacing={3} className={classes.grid}>
            <Grid item xs={12} sm={9}>
              <div className={classes.container}>
                <div className={classes.share}>
                  <AddThis url={window.location.href} />
                </div>
                <div><h1 className={classes.title}>{event.name}</h1></div>
                <div><h5 className={classes.eventdate}><b>{event.eventtime}</b> on {event.eventdate}</h5></div>
                <p>{event.description}</p>
                {/* <ul>
                  {event.categories && event.categories.map((category, index) => (
                    <li className={classes.category} key={index}>{category.title} - {category.name}</li>
                  ))}
                </ul>
                <p>{event.description2}</p> */}
                <p className={classes.footnote}>#StateOfInnovation</p>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Paper className={classes.paper}>
                <h3 className={classes.findmore}>Find out more</h3>
                <p className={classes.small}>Head to Channel Asia to find out more about the Innovation Awards, including finalists, categories, judges and past winners.</p>
                <Button variant="contained" color="primary" size="small" disableElevation className={classes.button} href="https://www.channelasia.tech/state_of_innovation" target="_blank" rel="noopener noreferrer">read more</Button>
              </Paper>
            </Grid>
          </Grid>
        }
        {event && event.content && event.content.sessions &&
          <div className={classes.sessions}>
            <h2 className={classes.agenda}>Agenda</h2>
            <Sessions config={event.content.sessions} setCurrentTime={setCurrentTime} />
          </div>
        }
      </Container>
    </>
  );
}
